import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { ConnectSixRules } from './ConnectSixRules';
export class ConnectSixAlignmentHeuristic extends Heuristic {
    getBoardValue(node, _config) {
        const state = node.gameState;
        let score = 0;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const squareScore = ConnectSixRules.CONNECT_SIX_HELPER.getSquareScore(state, coordAndContent.coord);
            score += squareScore;
        }
        return BoardValue.of(score);
    }
}
